import BASEURLPROJETOS from '../api/projetos'
import BASEAPIFORMDATA from '../api/formDataProjetos'
import { paramsUsuarioPayload, usuariosCadastrarPayload, usuariosAtualizarPayload, atualizarAvatarUsuario } from '../../interfaces/usuarios'

export function cadastrarUsuario(payload: usuariosCadastrarPayload) {
    return BASEURLPROJETOS.post('/usuario', payload)
}

export function listarUsuariosOrganizacao(params: paramsUsuarioPayload) {
    return BASEURLPROJETOS.get(`/usuario?termo=${params.termo}&situacao=${params.situacao}&idProjeto=${params.idProjeto}`)
}

export function atualizarUsuario(idUsuario: string, payload: usuariosAtualizarPayload) {
    return BASEURLPROJETOS.patch(`/usuario/${idUsuario}`, payload)
}

export function dadosUsuario() {
    return BASEURLPROJETOS.get('/usuario/dados')
}

export function atualizarAvatar(payload: atualizarAvatarUsuario) {
    return BASEAPIFORMDATA.put('/usuario/avatar', payload)
}

